import { View } from 'foundations-components/transitional/components/View';
import { useCitation } from '../Citation/useCitation/useCitation';
import { CitationPopoverBody } from './CitationPopoverBody';
import { CitationPopoverFooter } from './CitationPopoverFooter';
import { Skeleton } from 'breeze-intelligence-kit';
import { Section } from 'foundations-components/transitional/components/Section';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CitationPopoverContent = ({
  onDetailsClick,
  onSourcesClick
}) => {
  const {
    citation,
    isLoading,
    isError
  } = useCitation();
  if (isLoading) {
    return /*#__PURE__*/_jsxs(View, {
      padding: "500",
      children: [/*#__PURE__*/_jsx(Section, {
        children: /*#__PURE__*/_jsx(Skeleton, {
          blockSize: "32px",
          inlineSize: "100%",
          variant: "breeze"
        })
      }), /*#__PURE__*/_jsx(Section, {
        children: /*#__PURE__*/_jsx(Skeleton, {
          blockSize: "100px",
          inlineSize: "100%",
          variant: "breeze"
        })
      }), /*#__PURE__*/_jsx(Skeleton, {
        blockSize: "20px",
        inlineSize: "100%",
        variant: "breeze"
      })]
    });
  }
  if (isError || !citation) {
    return /*#__PURE__*/_jsx("div", {
      children: "Error"
    });
  }
  return /*#__PURE__*/_jsxs(View, {
    padding: "500",
    children: [/*#__PURE__*/_jsx(CitationPopoverBody, {
      citation: citation
    }), /*#__PURE__*/_jsx(CitationPopoverFooter, {
      citation: citation,
      onDetailsClick: onDetailsClick,
      onSourcesClick: onSourcesClick
    })]
  });
};